import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../actions';

export default function(ComposedComponent) {
  class Authentication extends Component {

    constructor(props) {
      super(props);
      this.state = { redirecting: false };
    }

    componentWillMount() {
      if(!this.props.login.token || !sessionStorage.jwt) {
        this.setState({ redirecting: true });
        this.context.router.history.push('/login');
        this.props.logout();
      } else if(sessionStorage.user === '5') {
        this.context.router.history.push('/dashboard');
      }
    }

    componentWillUpdate(nextProps) {
      if(!this.props.login.token || !sessionStorage.jwt) {
        this.context.router.history.push('/login');
        this.props.logout();
      } else if(sessionStorage.user === '5') {
        this.context.router.history.push('/dashboard');
      }
    }

    render() {
      // console.log('auth', this.props)
      if (!this.state.redirecting) return <ComposedComponent {...this.props} />;
      return '';
    }
  }
  Authentication.contextTypes = {
    router: PropTypes.object,
  };

  function mapStateToProps(state) {
    return {
      login: state.login,
      user: state.user,
      state,
    };
  }
  return connect(mapStateToProps, { logout })(Authentication);
}



// WEBPACK FOOTER //
// ./src/components/requireAuth.js